import styled from 'styled-components'

export const Wrapper = styled.div`
  gap: var(--spacer-2);
`

Wrapper.displayName = 'Wrapper'

export const Action = styled.button`
  background-color: transparent;
  transition: background-color 0.2s;

  &:hover:not([disabled]) {
    background-color: var(--gray-300);
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

Action.displayName = 'Action'
